import React from 'react';
import { IPropsWithChildren, IPropsWithClassName } from 'interfaces';
import { CalculatorStepState } from 'enums/calculator';

import { ReactComponent as CheckMarkIcon } from '@icons/checkmark.svg';
import { ReactComponent as ArrowIcon } from '@icons/chevron-right.svg';

import styles from './styles';

export interface StepButtonProps extends IPropsWithClassName, IPropsWithChildren {
  state?: CalculatorStepState
  arrow?: boolean
}

const StepButton = ({
  state = CalculatorStepState.INACTIVE,
  arrow = true,
  children,
  className,
  ...props
}: StepButtonProps & React.HTMLProps<HTMLButtonElement>) => (
  <button
    // @ts-ignore
    type="button"
    className={styles.component(className, state)}
    {...props}
  >
    <span className={styles.circle(state)}>
      <CheckMarkIcon />
    </span>
    <span className={styles.text}>
      {children}
    </span>
    { arrow && <ArrowIcon className={styles.arrow} />}
  </button>
);

export default StepButton;
